import React, { createContext, useState, useContext, useEffect } from 'react';
// import { base44 } from '@/api/base44Client';
// import { appParams } from '@/lib/app-params';
// import { createAxiosClient } from '@base44/sdk/dist/utils/axios-client';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({ name: 'Local User', email: 'local@example.com' }); // Mock user
  const [isAuthenticated, setIsAuthenticated] = useState(true); // Always authenticated locally
  const [isLoadingAuth, setIsLoadingAuth] = useState(false);
  const [isLoadingPublicSettings, setIsLoadingPublicSettings] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [appPublicSettings, setAppPublicSettings] = useState({ id: 'local-app' }); // Mock settings

  useEffect(() => {
    // Mock app state check
    setIsLoadingPublicSettings(false);
    setIsLoadingAuth(false);
  }, []);

  const logout = (shouldRedirect = true) => {
    // Mock logout
    console.log('Mock logout');
  };

  const navigateToLogin = () => {
    // Mock login
    console.log('Mock login');
  };

  const checkAppState = () => {
    // Mock check
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      isAuthenticated, 
      isLoadingAuth,
      isLoadingPublicSettings,
      authError,
      appPublicSettings,
      logout,
      navigateToLogin,
      checkAppState
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
